import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import Utils from '../utils.js';
import Utils3D from 'shared/libraries/mwc/3d/utils/utils3D';

import CSG3D from '../../../../csg3d';

const CSG_LIB = CSG3D;

export default class NodeDeleteByVolume extends Node
{
	static INTERSECT_CHOICES =
	[
		{key: 'keep', label: 'Keep Intersecting Meshes'},
		{key: 'delete', label: 'Delete Intersecting Meshes'},
		{key: 'cut', label: 'Cut Intersecting Meshes'},
	];

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);
		this.addInput(PARAM_TYPE.BBOX, 'volume', null);
		this.addInput(PARAM_TYPE.DROPDOWN, 'intersect_behavior', NodeDeleteByVolume.INTERSECT_CHOICES[0].key, { dropdownOptions: NodeDeleteByVolume.INTERSECT_CHOICES });

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{ 
		return 'deleteByVolume';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pGeoList = inputValues['geo'];
		if(!pGeoList || !Array.isArray(pGeoList))
			return null;

		// Get our bounding box
		let targetVolumeMin = inputValues['volume']?.minimumWorld;
		let targetVolumeMax = inputValues['volume']?.maximumWorld;

		if(!targetVolumeMin)
		{
			// See if it's a list of meshes:
			let volumeTargets = inputValues['volume'];
			if(!Array.isArray(volumeTargets))
				volumeTargets = [volumeTargets];
			volumeTargets = volumeTargets.filter((obj) => { return Utils.getIsMeshObject(obj); });
			if(volumeTargets.length > 0)
			{
				let bbox = Utils3D.getObjectsBBoxWithChildren(volumeTargets);
				targetVolumeMin = bbox.minimumWorld;
				targetVolumeMax = bbox.maximumWorld;
			}
		}

		if(!targetVolumeMin || !targetVolumeMax)
			return pGeoList;
			
		let volumeCutCSG = null;
		let pResList = [];
		for(let pSrcMesh of pGeoList)
		{
			if(!pSrcMesh)
				continue;

			if(!Utils.getIsMeshObject(pSrcMesh))
			{
				pResList.push(pSrcMesh);
				continue;
			}

			// Now, see if it matches or overlaps the geometry
			pSrcMesh.computeWorldMatrix();
			let meshBBox = Utils3D.getObjectsBBoxWithChildren(pSrcMesh);

			let doesContain = Utils3D.doesBBoxContain(targetVolumeMin, targetVolumeMax, meshBBox.minimumWorld, meshBBox.maximumWorld);
			let doesIntersect = !doesContain && Utils3D.doBBoxesIntersect(targetVolumeMin, targetVolumeMax, meshBBox.minimumWorld, meshBBox.maximumWorld);
			if(!doesContain && !doesIntersect
				|| (doesIntersect && inputValues['intersect_behavior'] == 'keep'))
			{
				pResList.push(pSrcMesh);
				continue;
			}

			// Otherwise, we contain or intersect.
			if(doesContain || (doesIntersect && inputValues['intersect_behavior'] == 'delete'))
			{
				pSrcMesh.dispose();
				continue;
			}

			// Otherwise, we're at the "we intersect and we need to cut" stage. Do so.
			if(!volumeCutCSG)
			{
				let size = targetVolumeMax.subtract(targetVolumeMin);
				let pBox = BABYLON.MeshBuilder.CreateBox('cutBox', { 
					width: size.x, 
					depth: size.z, 
					height: size.y,
					sideOrientation: BABYLON.Mesh.FRONTSIDE,
					updatable: false
				}, scene);

				pBox.position = targetVolumeMax.add(targetVolumeMin).scale(0.5);
				pBox.computeWorldMatrix();
				volumeCutCSG = CSG_LIB.CSG.FromMesh(pBox);

				pBox.dispose();
			}

			let meshCSG = CSG_LIB.CSG.FromMesh(pSrcMesh);
			let cutCSG = meshCSG.subtract(volumeCutCSG);

			let finalMesh = cutCSG.toMesh(pSrcMesh.name, pSrcMesh.material, scene);
			Utils3D.cloneCustomAttributes(finalMesh, pSrcMesh);

			pResList.push(finalMesh);
			pSrcMesh.dispose();

		}

		return pResList;
	}
}